export const LOGITECH_DEVICE_FILTERS = [
  {
    vendorId: 0x046d,
    usagePage: 1,
    usage: 4,
  },
];

const hasMatchingCollection = (
  collections = [],
  usagePage: number,
  usage: number,
) => {
  return collections.some((collection: any) => {
    if (collection == null) {
      return false;
    }

    if (collection.usagePage === usagePage && collection.usage === usage) {
      return true;
    }

    return hasMatchingCollection(collection.children || [], usagePage, usage);
  });
};

export const isAuthorizedLogitechWheel = (device: any) => {
  if (device == null || device.vendorId !== 0x046d) {
    return false;
  }

  return hasMatchingCollection(device.collections || [], 1, 4);
};

export const findAuthorizedLogitechWheel = (devices: any[] = []) => {
  return devices.find((device) => isAuthorizedLogitechWheel(device));
};
